import React from 'react';
import './ContactEnquiry.css';
import { openWhatsAppWithMessage } from '../utils/contact';

const ContactEnquiry = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const name = formData.get('name') || '';
    const email = formData.get('email') || '';
    const phone = formData.get('phone') || '';
    const topic = formData.get('topic') || '';

    const message = [
      'New QUICK ENQUIRY from mtpro.com',
      '',
      `Name: ${name}`,
      `Email: ${email}`,
      `Phone: ${phone}`,
      topic ? `Inquiry about: ${topic}` : '',
    ].join('\n');

    openWhatsAppWithMessage(message);
  };
  return (
    <section className="enquiry-section">
      <div className="enquiry-background">
        <img 
          src="https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80&w=1400" 
          alt="Office Background" 
          className="bg-image"
        />
        
        <div className="enquiry-card">
          <div className="enquiry-tag">QUICK ENQUIRY</div>
          <h2 className="enquiry-title">
            Get specialist advice for residential, <br /> 
            commercial or property
          </h2>

          <form className="enquiry-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <input type="text" name="name" placeholder="Your Name*" required />
              <input type="email" name="email" placeholder="Email*" required />
            </div>
            
            <div className="form-row">
              <input type="tel" name="phone" placeholder="Phone Number*" required />
              <select name="topic" defaultValue="">
                <option value="" disabled>You inquiry about...</option>
                <option value="pm">Project Management</option>
                <option value="telecom">Telecommunications</option>
                <option value="it">Information Technology</option>
              </select>
            </div>

            <div className="form-footer">
              <p className="form-note">
                We're excited to connect with you! <br />
                <span>Required fields are marked *</span>
              </p>
              
              <button type="submit" className="btn-callback">
                Get A Call Back
                <span className="btn-icon">↗</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactEnquiry;
